import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-skeleton-loading',
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: './skeleton-loading.component.html',
  styleUrl: './skeleton-loading.component.scss',
})
export class SkeletonLoadingComponent {}
